import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GitlabService } from '../../service';

export type ListUsersConfig = typeof ListUsersConfig._.Config;

export const ListUsersConfig = IntegrationConfig.make({
  service: GitlabService,
  name: Integration_Handler_Names_Enum.ListUsers,
  configSchema: z.object({
    groupId: z.number().int().positive().optional(),
    projectPatternFilter: patternFilterSchema.optional(),
  }),
});
